import { FileText } from 'lucide-react';
import { Image } from '../ui';

/** Same test FileUploadField uses to decide on a thumbnail, so a file looks the same wherever it's shown. */
const isImageUrl = (u: string) => /\.(png|jpe?g|webp|gif|svg)(\?|$)/i.test(u);

/**
 * Read-only view of ONE uploaded document (shop photo, GST certificate, KYC scan…).
 *
 * Images render as a click-to-zoom thumbnail; anything else (PDF, doc) becomes an "Open" button
 * that opens in a new tab. Returns null when there is no file, so the caller keeps control of its
 * own empty placeholder (an em-dash in a profile field, a "Not uploaded" line, …).
 */
export function DocumentPreview({ url, label }: { url?: string | null; label: string }) {
  if (!url) return null;
  return isImageUrl(url) ? (
    <Image
      src={url}
      alt={label}
      width={72}
      height={72}
      className="rounded-control border border-line"
      style={{ objectFit: 'cover' }}
      preview={{ src: url }}
    />
  ) : (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex h-8 items-center gap-1.5 rounded-control border border-line bg-surface px-2.5 type-body-strong leading-none text-content transition-colors duration-150 hover:border-brand-400 hover:text-brand-700 dark:hover:border-brand-500"
    >
      <FileText className="size-4" />
      <span>Open</span>
    </a>
  );
}
